import React, { useState, useEffect } from 'react';
import '../css/App.css';
import '../css/bootstrap.min.css';
import { NavLink } from 'react-router-dom';

class CookieMainMenu extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			user: this.props.user,
			permissions: this.props.permissions
		};
	}
	render() {

		return (
			<div className="board">
				<h2>{this.props.title}</h2>
				<header>
					<div className="row">
						<div className='col-6'>
							<h6>Recent</h6>
						</div>
						<div className='col-6'>
							<h6>Reload Recent</h6>
						</div>
					</div>
				</header>
				<div className='wrapper'>
				</div>
				<footer>
					<div className="row">
						<div className='col-6'>
							<NavLink to={`/cookies/orderslist`} className="btn-base">Main Menu</NavLink>
						</div>
						<div className='col-6'>
						</div>
					</div>
				</footer>
			</div>
		);
	}
}

export default CookieMainMenu;